export default {"src":"/_next/static/media/download.394c651b.svg","height":24,"width":24};